GloboSwatchConfig.settings = {
            enable_collection_page: true,
            enable_product_page: true,
            out_of_stock: "cross out",
            enable_mandatory: false,
            show_add_to_cart_button: true,
            add_to_cart_ajax: false,
            show_option_name: true,
            add_to_cart_text: "Add to cart",
            added_to_cart_text: "Added to cart",
            sold_out_text: "Sold out",
            text_required: "This field is required",
            sort_option: false,
            show_one_variant_product: false,
            show_one_variant_collection: false,
            group_image: false,
            show_limit_variant: false,
            limit_variant: "5",
        };
        GloboSwatchConfig.options = [{"id":64698,"name":"Gr\u00f6\u00dfe","shop_id":11258,"option_items":[{"id":1589893,"value":"onesize","option_id":64698,"products":null,"products_count":19,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1589895,"value":"M","option_id":64698,"products":null,"products_count":16,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}}],"display_style":4,"settings":{"status":true,"enable_collection":true,"type":"swatch"},"products":null,"products_count":19,"order":1},{"id":64699,"name":"Farbe","shop_id":11258,"option_items":[{"id":1589894,"value":"Grey Lucent","option_id":64699,"products":null,"products_count":13,"select_type":1,"custom":{"color_1":"#9b9b9b","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1589896,"value":"onesize","option_id":64699,"products":null,"products_count":2,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1589897,"value":"Anthracite Grey","option_id":64699,"products":null,"products_count":9,"select_type":1,"custom":{"color_1":"#615a48","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1589898,"value":"Print","option_id":64699,"products":null,"products_count":15,"select_type":3,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":"1634984138.png","server_url":"https:\/\/option.nyc3.digitaloceanspaces.com\/files\/marlenafrank.myshopify.com\/1634984138.png"},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":true,"enable_image_url":false}},{"id":1589899,"value":"Violet","option_id":64699,"products":null,"products_count":17,"select_type":1,"custom":{"color_1":"#9013fe","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1589900,"value":"White","option_id":64699,"products":null,"products_count":19,"select_type":1,"custom":{"color_1":"#ffffff","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1589901,"value":"Electric Blue","option_id":64699,"products":null,"products_count":11,"select_type":1,"custom":{"color_1":"#133c9c","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}}],"display_style":1,"settings":{"status":true,"enable_collection":true,"type":"swatch"},"products":null,"products_count":19,"order":2}];
        GloboSwatchConfig.product_page= {
                customize_swatch: {
                    swatch_shape: 'circle',
                    swatch_size: 'medium',
                    border_style: 'double',
                    border_color: {
                        normal: '#9b9b9b',
                        hover: '#58468c',
                        selected: '#58468c'
                    },
                    hover_effects:{
                        background: 'no effect',
                        zoom_image: 'no zoom',
                        size_change: 'no change'
                    }
                },
                customize_button: {
                    button_corner: 'sharp',
                    button_size: 'medium',
                    border_color: {
                        normal: '#000000',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    text_style: 'default',
                    text_color: {
                        normal: '#000000',
                        hover: '#ffffff',
                        selected: '#ffffff'
                    },
                    background_color: {
                        normal: '#FFFFFF',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    hover_effects:{
                        background: 'no effect',
                    }
                },
                show_number_stock: '',
                float: 'left'
            };
            GloboSwatchConfig.collection_page ={
                customize_swatch: {
                    swatch_shape: 'circle',
                    swatch_size: 'medium',
                    border_style: 'double',
                    border_color: {
                        normal: '#9b9b9b',
                        hover: '#58468c',
                        selected: '#58468c'
                    },
                    hover_effects:{
                        background: 'no effect',
                        zoom_image: 'no zoom',
                        size_change: 'no change'
                    }
                },
                customize_button: {
                    button_corner: 'sharp',
                    button_size: 'medium',
                    border_color: {
                        normal: '#000000',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    text_style: 'default',
                    text_color: {
                        normal: '#0a0a0a',
                        hover: '#ffffff',
                        selected: '#ffffff'
                    },
                    background_color: {
                        normal: '#ffffff',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    hover_effects:{
                        background: 'no effect',
                    }
                },
                float: 'left',
                carousel: 'disable'
        };